import { ApiEndpoint } from "@/app/apiEndpoint";
import axios from "@/app/http/axios";
import { Department } from "@/interface/Department.interface";
import { UserEndReason } from "@/interface/UserEndReason.interface";
import { UserInfo } from "@/interface/UserInfo.interface";
import countries from "i18n-iso-countries";

export default class MasterService {
  constructor() {}

  async getDepartments() {
    const path = ApiEndpoint.Gereral.GET_ALL_DPM;
    try {
      const response = await axios.get<Department[]>(`${path}`, {
        headers: { "Content-Type": "application/json" },
      });
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async getEmployeesInDpm(departmentCode: string) {
    const path = ApiEndpoint.Gereral.GET_DPM_EMP;
    try {
      const response = await axios.get(
        `${path.replace("{code}", departmentCode)}`,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async getAllEmployees() {
    const path = ApiEndpoint.Gereral.GET_ALL_EMP;
    try {
      const response = await axios.get(`${path}`, {
        headers: { "Content-Type": "application/json" },
      });
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async getEndReasons() {
    const path = ApiEndpoint.Gereral.GET_END_REASONS;
    try {
      const response = await axios.get<UserEndReason[]>(`${path}`, {
        headers: { "Content-Type": "application/json" },
      });
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  getCountryOptions(currentLocale: any) {
    // Retrieve country names and map to options with name and code
    const countryNames = countries.getNames(currentLocale);

    // List of prioritized country codes
    const prioritizedCountries = ["TH", "US"];

    // Separate prioritized countries
    const prioritizedOptions = prioritizedCountries
      .map((code) => ({
        code: code.toLowerCase(),
        name: countryNames[code] || code, // Fallback to code if name not found
      }))
      .filter((option) => option.name); // Remove empty names in case of missing data

    // Remaining countries sorted alphabetically by name
    const otherOptions = Object.entries(countryNames)
      .filter(([code]) => !prioritizedCountries.includes(code))
      .map(([code, name]) => ({ code: code.toLowerCase(), name }))
      .sort((a, b) => a.name.localeCompare(b.name));

    // Combine prioritized countries with others
    return [...prioritizedOptions, ...otherOptions];
  }

  async getExternalUsers() {
    const path = ApiEndpoint.Gereral.GET_USERS;
    try {
      const response = await axios.get<UserInfo[]>(`${path}`, {
        headers: { "Content-Type": "application/json" },
      });
      return response;
    } catch (error: any) {
      throw error;
    }
  }
}
